import { Controller } from "@hotwired/stimulus"

// datetime-local input を 15 分刻みに丸めるためのコントローラー。
// 分割 UI が使えない狭いセル (workspace の候補者行) で利用する。
//
// 使い方:
//   input 自身に
//     data-controller="quarter-hour"
//     data-action="change->quarter-hour#round"
//   を付ける。
export default class extends Controller {
  round(event) {
    const el = event && event.target
    if (!el || !el.value) return
    const d = new Date(el.value)
    if (isNaN(d.getTime())) return
    const rounded = Math.round(d.getMinutes() / 15) * 15
    d.setMinutes(rounded)
    d.setSeconds(0)
    d.setMilliseconds(0)
    const pad = n => String(n).padStart(2, "0")
    const formatted = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
    if (el.value !== formatted) {
      el.value = formatted
      el.dispatchEvent(new Event("input", { bubbles: true }))
      el.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }
}
